import SolutionEdgeWorkload from './SolutionEdgeWorkload';

export default SolutionEdgeWorkload;
